/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaCellNote from './AqaCellNote';

/**
 * The AqaRowCellNoteBlock model module.
 * @module model/AqaRowCellNoteBlock
 * @version v0
 */
export default class AqaRowCellNoteBlock {
  /**
   * Constructs a new <code>AqaRowCellNoteBlock</code>.
   * @alias module:model/AqaRowCellNoteBlock
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaRowCellNoteBlock</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaRowCellNoteBlock} obj Optional instance to populate.
   * @return {module:model/AqaRowCellNoteBlock} The populated <code>AqaRowCellNoteBlock</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaRowCellNoteBlock();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('noterows'))
        obj.noterows = ApiClient.convertToType(data['noterows'], {'String': [AqaCellNote]});
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaRowCellNoteBlock.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaRowCellNoteBlock.prototype.message = undefined;

/**
 * @member {Object.<String, Array.<module:model/AqaCellNote>>} noterows
 */
AqaRowCellNoteBlock.prototype.noterows = undefined;

/**
 * @member {Boolean} successful
 */
AqaRowCellNoteBlock.prototype.successful = undefined;

